/**
 * mSTEM Phase 6 / EXT-01 step-3 mock peripheral list (DR-01, MOCK-ONLY).
 * The 8 selectable sensor/actuator modules shown as multi-select checkboxes
 * in the Device Declaration wizard. Each entry is {id, name}; the VN name is
 * the rendered default (06-02 wires the i18n ids gen.ext.device.peripheral.*).
 * No backend — pure UI seed data.
 */
const EXT_PERIPHERALS = [
    {id: 'ultrasonic', name: 'Cảm biến siêu âm'},
    {id: 'dht', name: 'Cảm biến nhiệt độ - độ ẩm (DHT)'},
    {id: 'relay', name: 'Relay'},
    {id: 'servo', name: 'Servo'},
    {id: 'rfid', name: 'Đầu đọc RFID'},
    {id: 'ledMatrix', name: 'LED ma trận 8×8'},
    {id: 'buzzer', name: 'Còi buzzer'},
    {id: 'lightSensor', name: 'Cảm biến ánh sáng'}
];

export default EXT_PERIPHERALS;
